import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class MapsService implements IService {

    constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

    getTitle = (): string => 'Maps';

    getAllThemes = (): Array<any> => {
        return [
            { 'url': 'maps/0', 'title': 'GMAPS + Location  Details', 'theme': 'layout1' },
            { 'url': 'maps/1', 'title': 'GMAPS + Reviews', 'theme': 'layout2' },
            { 'url': 'maps/2', 'title': 'Full Screen View', 'theme': 'layout3' }
        ];
    }

    getDataForTheme = (menuItem: any): any => {
        return this[
            'getDataFor' +
            menuItem.theme.charAt(0).toUpperCase() +
            menuItem.theme.slice(1)
        ]();
    }

    //* Data Set for page 1
    getDataForLayout1 = (): any => {
        return {
            'toolbarTitle': 'GMAPS + Location  Details',
            'title': 'New York Hotels',
            'titleDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using',
            'reviews': '78 reviews',
            'iconPin': "location",
            'iconPhone': 'call',
            'iconShare': 'share-social',
            'iconGlobe': 'globe',
            'workTime': 'Mon - Sat (8:00 AM - 11PM)',
            'workTimeWeek': 'Sat - Sun (11AM - 11PM)',
            'map': {
                'lat': 40.712562,
                'lng': -74.005911,
                'zoom': 15,
                'mapTypeControl': true,
                'streetViewControl': true
            },
            "iconsStars": [
                {
                  "icon": "star",
                },
                {
                  "icon": "star"
                },
                {
                  "icon": "star"
                },
                {
                  "icon": "star"
                },
                {
                  "icon": "star-outline"
                }
            ],
            "images": [
                {
                  "image": "assets/imgs/background/6.jpg",
                },
                {
                  "image": "assets/imgs/background/9.jpg"
                },
                {
                  "image": "assets/imgs/background/8.jpg"
                },
                {
                  "image": "assets/imgs/background/7.jpg"
                },
                {
                  "image": "assets/imgs/background/5.jpg"
                },
                {
                  "image": "assets/imgs/background/6.jpg"
                }
            ],

        };
    }

    //* Data Set for page 2
    getDataForLayout2 = (): any => {
        return {
            'toolbarTitle': 'GMAPS + Reviews',
            'title': 'Reviews',
            'subtitle': 'Similar Lists',
            'seeAll': 'See All',
            'icon': 'arrow-forward',
            'avatar': 'assets/imgs/avatar/23.jpg',
            'avatarTitle': 'Jason Graham',
            'avatarSubitle': 'Latest Tenant',
            'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using ',
            'map': {
                'lat': 40.712562,
                'lng': -74.005911,
                'zoom': 15,
                'mapTypeControl': true,
                'streetViewControl': true
            },
            'items': [
                {
                    'id': 1,
                    'title': '45 Park Lane',
                    'subtitle': '2 beds',
                    'price': '$ 300 per month',
                    'image': 'assets/imgs/background/8.jpg',
                },
                {
                    'id': 2,
                    'title': 'Encore Macau',
                    'subtitle': '2 beds',
                    'price': '$ 300 per month',
                    'image': 'assets/imgs/background/9.jpg',
                },
                {
                    'id': 3,
                    'title': 'Bulgari Hotel London',
                    'subtitle': '2 beds',
                    'price': '$ 300 per month',
                    'image': 'assets/imgs/background/6.jpg',
                },
                {
                    'id': 4,
                    'title': 'Belmond El Encanto',
                    'subtitle': '2 beds',
                    'price': '$ 300 per month',
                    'image': 'assets/imgs/background/5.jpg',
                },
                {
                    'id': 5,
                    'title': 'The Alpina Gstaad',
                    'subtitle': '2 beds',
                    'price': '$ 300 per month',
                    'image': 'assets/imgs/background/7.jpg',
                },
            ]
        };
    }

    //* Data Set for page 3
    getDataForLayout3 = (): any => {
        return {
            'toolbarTitle': 'Full Screen View',
            'map': {
                'lat': 40.712562,
                'lng': -74.005911,
                'zoom': 15,
                'mapTypeControl': true,
                'streetViewControl': true
            },
        };
    }

    load(item: any): Observable<any> {
        this.loadingService.show();
        if (AppSettings.IS_FIREBASE_ENABLED) {
            return new Observable(observer => {
                this.af
                    .object('maps/' + item.theme)
                    .valueChanges()
                    .subscribe(snapshot => {
                        this.loadingService.hide();
                        observer.next(snapshot);
                        observer.complete();
                    }, err => {
                        this.loadingService.hide();
                        observer.error([]);
                        observer.complete();
                    });
            });
        } else {
            return new Observable(observer => {
                this.loadingService.hide();
                observer.next(this.getDataForTheme(item));
                observer.complete();
            });
        }
    }
}
